import { render, staticRenderFns } from "./contrastDemons.vue?vue&type=template&id=e3574580"
import script from "./contrastDemons.vue?vue&type=script&lang=js"
export * from "./contrastDemons.vue?vue&type=script&lang=js"
import style0 from "./contrastDemons.vue?vue&type=style&index=0&id=e3574580&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports